import { WithChildren, AppPageWrapper } from "@duosoftbg/nacid-components";
import Breadcrumbs from "./Breadcrumbs";
import React from "react";

type PageWrapperProps = WithChildren<{
  title?: string;
  centerTitle?: boolean;
  helmetTitle?: string;
}>;

const PageWrapper = (props: PageWrapperProps) => {
  const { title, centerTitle, children, helmetTitle = title } = props;

  return (
    <AppPageWrapper
      helmetTitle={helmetTitle}
      children={children}
      title={title}
      centerTitle={centerTitle}
      breadcrumbs={<Breadcrumbs />}
    />
  );
};

export default PageWrapper;
